var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1067,
    height: 816,
    viewBox: "0 0 1067 816",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1000.1 300.236C1087.65 331.835 1088.34 455.414 1001.14 487.979L142.12 808.78C78.4243 832.567 10.0726 787.224 7.22273 719.291L-19.6489 78.7694C-22.6283 7.75281 47.3523 -43.6131 114.21 -19.4838L1000.1 300.236Z",
    fill: "#F5F9FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.220d8d1b76d49e54f5c8d13daee9f9e5.svg";
export { ForwardRef as ReactComponent };